(function observeSwymAddToCartClicks() {
  var buttonSelector = 'button.swym-add-to-cart-btn';
  var attachedAttribute = 'data-safeguard-attached';
  var scanQueued = false;
  var observerStarted = false;

  function refreshCartWithFallback() {
    // Delay to allow Swym to process the cart update
    setTimeout(function() {
      fetch('/cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        })
        .catch(function(err) {
          console.warn('[Swym Fallback] Failed to fetch cart:', err);
        });
    }, 1000);
  }

  function attachClickFallback(button) {
    if (button.getAttribute(attachedAttribute) === 'true') return;
    button.setAttribute(attachedAttribute, 'true');
    button.addEventListener('click', refreshCartWithFallback);
  }

  function scanForButtons(root) {
    var searchRoot = root || document;
    var buttons = searchRoot.querySelectorAll(
      buttonSelector + ':not([' + attachedAttribute + '])'
    );

    buttons.forEach(attachClickFallback);
  }

  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;

    setTimeout(function() {
      scanQueued = false;
      scanForButtons();
    }, 100);
  }

  function startObserver() {
    if (observerStarted || !document.body) return;
    observerStarted = true;

    scanForButtons();

    var observer = new MutationObserver(function(mutations) {
      var shouldScan = mutations.some(function(mutation) {
        return mutation.addedNodes && mutation.addedNodes.length > 0;
      });

      if (shouldScan) {
        queueScan();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function boot() {
    var shouldStartImmediately = !!window.SwymCallbacks || !!document.querySelector(buttonSelector);

    if (shouldStartImmediately) {
      startObserver();
      return;
    }

    var interactionEvents = ['scroll', 'mousemove', 'touchstart', 'keydown'];
    var interactionHandled = false;

    function onInteraction() {
      if (interactionHandled) return;
      interactionHandled = true;

      interactionEvents.forEach(function(eventName) {
        window.removeEventListener(eventName, onInteraction);
      });

      startObserver();
    }

    interactionEvents.forEach(function(eventName) {
      window.addEventListener(eventName, onInteraction, { once: true, passive: true });
    });

    // Safety fallback to ensure support on low-interaction sessions.
    setTimeout(startObserver, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
